// views/drops/DropsHome.vue
<template>
  <div class="drops-home">
    <div class="control-panel">
      <div class="search-bar">
        <input 
          type="text" 
          v-model="searchQuery"
          placeholder="Type to search for a game"
          class="search-input"
        >
      </div>
      
      <div class="sort-controls">
        <select v-model="sortOption" class="sort-select">
          <option value="priority">Sort by Priority</option>
          <option value="name">Sort by Name</option>
          <option value="drops">Sort by Drops</option>
          <option value="rewards">Sort by Rewards</option>
          <option value="newest">Sort by Newest</option>
        </select>
        
        <button 
          @click="toggleSortDirection" 
          class="sort-direction-btn"
          :class="{ 'desc': sortDirection === 'desc' }"
        >
          <span class="arrow-icon">↑</span>
        </button>
      </div>
    </div>

    <!-- <div class="info-banner">
      <i class="info-icon"></i>
      Earn points and redeem any drop you want.
    </div> -->
    <AnnouncementBanner 
    :announcement="currentAnnouncement"
    :showCloseButton="true"
    @close="handleClose"
  />

    <p class="games-hint">Click the game to see available drops</p>

    <div class="games-grid">
      <div 
        v-for="game in sortedAndFilteredGames" 
        :key="game.game_id"
        class="game-card"
        :class="{ 'priority': game.priority }"
        @click="handleGameClick(game)"
      >
        <div class="game-image">
          <img :src="getImageUrl(game.imagePath)" :alt="game.name">
          <div v-if="game.priority" class="priority-badge">Priority</div>
        </div>
        <div class="game-info">
          <h3 class="game-title">{{ game.name }}</h3>
          <div class="game-stats">
            <span class="drops">{{ game.drops }} Drops</span>
            <span class="rewards">{{ game.rewards }} Rewards</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

import AnnouncementBanner from '../components/AnnouncementBanner.vue'

const currentAnnouncement = ref({
  message: 'Earn points and redeem any drop you want.',
  icon: 'info-icon',
  type: 'success' // 可选值: info, success, warning, error
})
const handleClose = () => {
  // 处理关闭事件
  currentAnnouncement.value = null
}

// 模拟一些游戏有优先级
const games = ref([
    {
        "id": 3,
        "imagePath": "/games/sea-of-thieves.png",
        "name": "Sea of Thieves",
        "permalink": "sea-of-thieves",
        "drops": 9,
        "rewards": "44"
    },
    {
        "id": 7,
        "imagePath": "/games/elder-scrolls-online.jpg",
        "name": "The Elder Scrolls Online",
        "permalink": "elder-scrolls-online",
        "drops": 7,
        "rewards": "14"
    },
    {
        "id": 6,
        "imagePath": "/games/overwatch-2.jpg",
        "name": "Overwatch 2",
        "permalink": "overwatch-2",
        "drops": 8,
        "rewards": "22"
    },
    {
        "id": 10,
        "imagePath": "/games/vampire-the-masquerade-bloodhunt.jpg",
        "name": "Vampire: The Masquerade - Bloodhunt",
        "permalink": "vampire-the-masquerade-bloodhunt",
        "drops": 15,
        "rewards": "68"
    },
    {
        "id": 11,
        "imagePath": "/games/the-cycle-frontier.jpg",
        "name": "The Cycle: Frontier",
        "permalink": "the-cycle-frontier",
        "drops": 2,
        "rewards": "59"
    },
    {
        "id": 12,
        "imagePath": "/games/new-world.jpg",
        "name": "New World",
        "permalink": "new-world",
        "drops": 3,
        "rewards": "15"
    },
    {
        "id": 13,
        "imagePath": "/games/black-desert.jpg",
        "name": "Black Desert",
        "permalink": "black-desert",
        "drops": 14,
        "rewards": "43"
    },
    {
        "id": 15,
        "imagePath": "/games/escape-from-tarkov.jpg",
        "name": "Escape from Tarkov",
        "permalink": "escape-from-tarkov",
        "drops": 12,
        "rewards": "81"
    },
    {
        "id": 17,
        "imagePath": "/games/hearthstone.jpg",
        "name": "Hearthstone",
        "permalink": "hearthstone",
        "drops": 3,
        "rewards": "8"
    },
    {
        "id": 18,
        "imagePath": "/games/world-of-warcraft.jpg",
        "name": "World of Warcraft",
        "permalink": "world-of-warcraft",
        "drops": 2,
        "rewards": "2"
    },
    {
        "id": 5,
        "imagePath": "/games/rainbow-six-siege.jpg",
        "name": "Tom Clancy's Rainbow Six Siege",
        "permalink": "rainbow-six-siege",
        "drops": 2,
        "rewards": "22"
    },
    {
        "id": 4,
        "imagePath": "/games/hogwarts-legacy.jpg",
        "name": "Hogwarts Legacy",
        "permalink": "hogwarts-legacy",
        "drops": 1,
        "rewards": "11"
    },
    {
        "id": 16,
        "imagePath": "/games/halo-infinite.jpg",
        "name": "Halo Infinite",
        "permalink": "halo-infinite",
        "drops": 35,
        "rewards": "67"
    },
    {
        "id": 19,
        "imagePath": "/games/cult-of-the-lamb.jpg",
        "name": "Cult of the Lamb",
        "permalink": "cult-of-the-lamb",
        "drops": 2,
        "rewards": "10"
    },
    {
        "id": 14,
        "imagePath": "/games/caliber.jpg",
        "name": "Caliber",
        "permalink": "caliber",
        "drops": 5,
        "rewards": "70"
    },
    {
        "id": 20,
        "imagePath": "/games/paladins.jpg",
        "name": "Paladins",
        "permalink": "paladins",
        "drops": 1,
        "rewards": "36"
    },
    {
        "id": 21,
        "imagePath": "/games/rust.jpg",
        "name": "Rust",
        "permalink": "rust",
        "drops": 32,
        "rewards": "132"
    },
    {
        "id": 22,
        "imagePath": "/games/conquerors-blade.jpg",
        "name": "Conqueror's Blade",
        "permalink": "conquerors-blade",
        "drops": 2,
        "rewards": "13"
    },
    {
        "id": 23,
        "imagePath": "/games/diablo-iv.png",
        "name": "Diablo IV",
        "permalink": "diablo-iv",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 24,
        "imagePath": "/games/guild-wars-2.jpg",
        "name": "Guild Wars 2",
        "permalink": "guild-wars-2",
        "drops": 1,
        "rewards": "6"
    },
    {
        "id": 26,
        "imagePath": "/games/world-of-tanks.jpg",
        "name": "World of Tanks",
        "permalink": "world-of-tanks",
        "drops": 21,
        "rewards": "48"
    },
    {
        "id": 9,
        "imagePath": "/games/albion-online.jpg",
        "name": "Albion Online",
        "permalink": "albion-online",
        "drops": 22,
        "rewards": "83"
    },
    {
        "id": 8,
        "imagePath": "/games/call-of-duty-modern-warfare-2.jpg",
        "name": "Call of Duty: Modern Warfare II",
        "permalink": "call-of-duty-modern-warfare-2",
        "drops": 2,
        "rewards": "79"
    },
    {
        "id": 27,
        "imagePath": "/games/battleBit-remastered.jpg",
        "name": "BattleBit Remastered",
        "permalink": "battleBit-remastered",
        "drops": 12,
        "rewards": "195"
    },
    {
        "id": 25,
        "imagePath": "/games/payday-2.jpg",
        "name": "PAYDAY 2",
        "permalink": "payday-2",
        "drops": 1,
        "rewards": "13"
    },
    {
        "id": 28,
        "imagePath": "/games/pubg.png",
        "name": "PUBG: BATTLEGROUNDS",
        "permalink": "pubg",
        "drops": 11,
        "rewards": "33",
        "priority": true,
        "created_at": "2024-01-01"
    },
    {
        "id": 29,
        "imagePath": "/games/among-us.jpg",
        "name": "Among Us",
        "permalink": "among-us",
        "drops": 1,
        "rewards": "1",
        "priority": true,
        "created_at": "2025-01-01"
    },
    {
        "id": 30,
        "imagePath": "/games/baldurs-gate-3.jpg",
        "name": "Baldur's Gate 3",
        "permalink": "baldurs-gate-3",
        "drops": 2,
        "rewards": "2",
        "priority": true,
        "created_at": "2025-01-10"
    },
    {
        "id": 31,
        "imagePath": "/games/path-of-exile.jpg",
        "name": "Path of Exile",
        "permalink": "path-of-exile",
        "drops": 2,
        "rewards": "2"
    },
    {
        "id": 33,
        "imagePath": "/games/assassins-creed-valhalla.jpg",
        "name": "Assassin's Creed Valhalla",
        "permalink": "assassins-creed-valhalla",
        "drops": 2,
        "rewards": "5"
    },
    {
        "id": 34,
        "imagePath": "/games/rocket-league.jpg",
        "name": "Rocket League",
        "permalink": "rocket-league",
        "drops": 3,
        "rewards": "9"
    },
    {
        "id": 35,
        "imagePath": "/games/tower-of-fantasy.jpg",
        "name": "Tower of Fantasy",
        "permalink": "tower-of-fantasy",
        "drops": 4,
        "rewards": "25"
    },
    {
        "id": 32,
        "imagePath": "/games/marauders.jpg",
        "name": "Marauders",
        "permalink": "marauders",
        "drops": 1,
        "rewards": "8"
    },
    {
        "id": 36,
        "imagePath": "/games/genshin-impact.jpg",
        "name": "Genshin Impact",
        "permalink": "genshin-impact",
        "drops": 4,
        "rewards": "20"
    },
    {
        "id": 38,
        "imagePath": "/games/my-hero-ultra-rumble.jpg",
        "name": "My Hero Ultra Rumble",
        "permalink": "my-hero-ultra-rumble",
        "drops": 1,
        "rewards": "6"
    },
    {
        "id": 39,
        "imagePath": "/games/party-animals.jpg",
        "name": "Party Animals",
        "permalink": "party-animals",
        "drops": 5,
        "rewards": "24"
    },
    {
        "id": 40,
        "imagePath": "/games/call-of-duty-mw-3.jpg",
        "name": "Call of Duty: Modern Warfare III",
        "permalink": "call-of-duty-mw-3",
        "drops": 3,
        "rewards": "11"
    },
    {
        "id": 41,
        "imagePath": "/games/cyberpunk-2077.jpg",
        "name": "Cyberpunk 2077",
        "permalink": "cyberpunk-2077",
        "drops": 2,
        "rewards": "7"
    },
    {
        "id": 45,
        "imagePath": "/games/shakes-and-fidget.jpg",
        "name": "Shakes and Fidget",
        "permalink": "shakes-and-fidget",
        "drops": 15,
        "rewards": "144"
    },
    {
        "id": 46,
        "imagePath": "/games/valorant.jpg",
        "name": "VALORANT",
        "permalink": "valorant",
        "drops": 5,
        "rewards": "5"
    },
    {
        "id": 47,
        "imagePath": "/games/eve-online.jpg",
        "name": "EVE Online",
        "permalink": "eve-online",
        "drops": 9,
        "rewards": "14"
    },
    {
        "id": 48,
        "imagePath": "/games/out-of-the-park-baseball-24.jpg",
        "name": "Out of the Park Baseball 24",
        "permalink": "out-of-the-park-baseball-24",
        "drops": 2,
        "rewards": "12"
    },
    {
        "id": 49,
        "imagePath": "/games/eternal-return.jpg",
        "name": "Eternal Return",
        "permalink": "eternal-return",
        "drops": 20,
        "rewards": "31"
    },
    {
        "id": 50,
        "imagePath": "/games/mir-korabley.jpg",
        "name": "Mir Korabley",
        "permalink": "mir-korabley",
        "drops": 5,
        "rewards": "9"
    },
    {
        "id": 51,
        "imagePath": "/games/race-day-rampage.jpg",
        "name": "Race Day Rampage",
        "permalink": "race-day-rampage",
        "drops": 3,
        "rewards": "19"
    },
    {
        "id": 52,
        "imagePath": "/games/kirka.io.jpg",
        "name": "Kirka.io",
        "permalink": "kirka.io",
        "drops": 4,
        "rewards": "7"
    },
    {
        "id": 53,
        "imagePath": "/games/naraka-bladepoint.jpg",
        "name": "NARAKA: BLADEPOINT",
        "permalink": "naraka-bladepoint",
        "drops": 9,
        "rewards": "29"
    },
    {
        "id": 54,
        "imagePath": "/games/nitro-stream-racing.jpg",
        "name": "Nitro: Stream Racing",
        "permalink": "nitro-stream-racing",
        "drops": 6,
        "rewards": "24"
    },
    {
        "id": 55,
        "imagePath": "/games/assassins-creed-mirage.jpg",
        "name": "Assassin's Creed Mirage",
        "permalink": "assassins-creed-mirage",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 56,
        "imagePath": "/games/assassins-creed-odyssey.jpg",
        "name": "Assassin's Creed Odyssey",
        "permalink": "assassins-creed-odyssey",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 57,
        "imagePath": "/games/goose-goose-duck.jpg",
        "name": "Goose Goose Duck",
        "permalink": "goose-goose-duck",
        "drops": 4,
        "rewards": "13"
    },
    {
        "id": 58,
        "imagePath": "/games/kakele-online-mmorpg.jpg",
        "name": "Kakele Online: MMORPG",
        "permalink": "kakele-online-mmorpg",
        "drops": 3,
        "rewards": "50"
    },
    {
        "id": 59,
        "imagePath": "/games/smite.jpg",
        "name": "SMITE",
        "permalink": "smite",
        "drops": 11,
        "rewards": "64"
    },
    {
        "id": 60,
        "imagePath": "/games/dead-island-2.jpg",
        "name": "Dead Island 2",
        "permalink": "dead-island-2",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 61,
        "imagePath": "/games/my-time-at-sandrock.jpg",
        "name": "My Time at Sandrock",
        "permalink": "my-time-at-sandrock",
        "drops": 1,
        "rewards": "3"
    },
    {
        "id": 62,
        "imagePath": "/games/warhaven.jpg",
        "name": "Warhaven",
        "permalink": "warhaven",
        "drops": 5,
        "rewards": "16"
    },
    {
        "id": 63,
        "imagePath": "/games/arena-breakout.jpg",
        "name": "Arena Breakout",
        "permalink": "arena-breakout",
        "drops": 3,
        "rewards": "7"
    },
    {
        "id": 64,
        "imagePath": "/games/dragonheir-silent-gods.jpg",
        "name": "Dragonheir: Silent Gods",
        "permalink": "dragonheir-silent-gods",
        "drops": 2,
        "rewards": "10"
    },
    {
        "id": 65,
        "imagePath": "/games/dc-dual-force.jpg",
        "name": "DC Dual Force",
        "permalink": "dc-dual-force",
        "drops": 2,
        "rewards": "9"
    },
    {
        "id": 66,
        "imagePath": "/games/deceive-inc.jpg",
        "name": "Deceive Inc.",
        "permalink": "deceive-inc",
        "drops": 2,
        "rewards": "6"
    },
    {
        "id": 67,
        "imagePath": "/games/ea-sports-fc-24.jpg",
        "name": "EA Sports FC 24",
        "permalink": "ea-sports-fc-24",
        "drops": 8,
        "rewards": "17"
    },
    {
        "id": 68,
        "imagePath": "/games/lost-ark.jpg",
        "name": "Lost Ark",
        "permalink": "lost-ark",
        "drops": 3,
        "rewards": "7"
    },
    {
        "id": 69,
        "imagePath": "/games/summoners-war-chronicles.jpg",
        "name": "Summoners War: Chronicles",
        "permalink": "summoners-war-chronicles",
        "drops": 1,
        "rewards": "4"
    },
    {
        "id": 70,
        "imagePath": "/games/pokemon-go.jpg",
        "name": "Pok\u00e9mon GO",
        "permalink": "pokemon-go",
        "drops": 1,
        "rewards": "0"
    },
    {
        "id": 71,
        "imagePath": "/games/king-of-the-castle.jpg",
        "name": "King of the Castle",
        "permalink": "king-of-the-castle",
        "drops": 1,
        "rewards": "22"
    },
    {
        "id": 72,
        "imagePath": "/games/conan-exiles.jpg",
        "name": "Conan Exiles",
        "permalink": "conan-exiles",
        "drops": 3,
        "rewards": "4"
    },
    {
        "id": 73,
        "imagePath": "/games/endless-dungeon.jpg",
        "name": "Endless Dungeon",
        "permalink": "endless-dungeon",
        "drops": 5,
        "rewards": "9"
    },
    {
        "id": 74,
        "imagePath": "/games/world-of-warships.jpg",
        "name": "World of Warships",
        "permalink": "world-of-warships",
        "drops": 12,
        "rewards": "26"
    },
    {
        "id": 75,
        "imagePath": "/games/xera-survival.jpg",
        "name": "XERA: Survival",
        "permalink": "xera-survival",
        "drops": 3,
        "rewards": "15"
    },
    {
        "id": 76,
        "imagePath": "/games/warframe.jpg",
        "name": "Warframe",
        "permalink": "warframe",
        "drops": 7,
        "rewards": "7"
    },
    {
        "id": 77,
        "imagePath": "/games/marbles-on-stream.jpg",
        "name": "Marbles on Stream",
        "permalink": "marbles-on-stream",
        "drops": 17,
        "rewards": "22"
    },
    {
        "id": 78,
        "imagePath": "/games/pokemon-trading-card-game.jpg",
        "name": "Pok\u00e9mon Trading Card Game",
        "permalink": "pokemon-trading-card-game",
        "drops": 1,
        "rewards": "6"
    },
    {
        "id": 79,
        "imagePath": "/games/legion-td-2.jpg",
        "name": "Legion TD 2",
        "permalink": "legion-td-2",
        "drops": 3,
        "rewards": "9"
    },
    {
        "id": 80,
        "imagePath": "/games/tanki-online.jpg",
        "name": "Tanki Online",
        "permalink": "tanki-online",
        "drops": 17,
        "rewards": "20"
    },
    {
        "id": 81,
        "imagePath": "/games/madden-nfl-24.jpg",
        "name": "Madden NFL 24",
        "permalink": "madden-nfl-24",
        "drops": 12,
        "rewards": "21"
    },
    {
        "id": 82,
        "imagePath": "/games/undying.jpg",
        "name": "Undying",
        "permalink": "undying",
        "drops": 4,
        "rewards": "12"
    },
    {
        "id": 84,
        "imagePath": "/games/hawked.jpg",
        "name": "HAWKED",
        "permalink": "hawked",
        "drops": 4,
        "rewards": "5"
    },
    {
        "id": 87,
        "imagePath": "/games/dofus.jpg",
        "name": "Dofus",
        "permalink": "dofus",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 88,
        "imagePath": "/games/ninja-must-die.jpg",
        "name": "Ninja Must Die",
        "permalink": "ninja-must-die",
        "drops": 2,
        "rewards": "10"
    },
    {
        "id": 89,
        "imagePath": "/games/temtem.jpg",
        "name": "Temtem",
        "permalink": "temtem",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 91,
        "imagePath": "/games/apex-legends.jpg",
        "name": "Apex Legends",
        "permalink": "apex-legends",
        "drops": 8,
        "rewards": "22"
    },
    {
        "id": 92,
        "imagePath": "/games/the-crew-motorfest.jpg",
        "name": "The Crew: Motorfest",
        "permalink": "the-crew-motorfest",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 93,
        "imagePath": "/games/pokemon-unite.jpg",
        "name": "Pok\u00e9mon UNITE",
        "permalink": "pokemon-unite",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 94,
        "imagePath": "/games/call-of-duty-warzone.jpg",
        "name": "Call of Duty: Warzone",
        "permalink": "call-of-duty-warzone",
        "drops": 1,
        "rewards": "9"
    },
    {
        "id": 95,
        "imagePath": "/games/neon-abyss-infinity.jpg",
        "name": "Neon Abyss: Infinity",
        "permalink": "neon-abyss-infinity",
        "drops": 4,
        "rewards": "20"
    },
    {
        "id": 96,
        "imagePath": "/games/avatar-frontiers-of-pandora.jpg",
        "name": "Avatar: Frontiers of Pandora",
        "permalink": "avatar-frontiers-of-pandora",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 97,
        "imagePath": "/games/dungeon-fighter-online.jpg",
        "name": "Dungeon Fighter Online",
        "permalink": "dungeon-fighter-online",
        "drops": 1,
        "rewards": "6"
    },
    {
        "id": 86,
        "imagePath": "/games/archeage.jpg",
        "name": "ArcheAge",
        "permalink": "archeage",
        "drops": 2,
        "rewards": "8"
    },
    {
        "id": 98,
        "imagePath": "/games/teamfight-tactics.jpg",
        "name": "Teamfight Tactics",
        "permalink": "teamfight-tactics",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 99,
        "imagePath": "/games/warface.jpg",
        "name": "Warface",
        "permalink": "warface",
        "drops": 2,
        "rewards": "6"
    },
    {
        "id": 100,
        "imagePath": "/games/gwent-the-witcher-card-game.jpg",
        "name": "Gwent: The Witcher Card Game",
        "permalink": "gwent-the-witcher-card-game",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 101,
        "imagePath": "/games/chess.jpg",
        "name": "Chess",
        "permalink": "chess",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 102,
        "imagePath": "/games/relic-hunters-legend.jpg",
        "name": "Relic Hunters Legend",
        "permalink": "relic-hunters-legend",
        "drops": 1,
        "rewards": "4"
    },
    {
        "id": 103,
        "imagePath": "/games/mir-tankov.jpg",
        "name": "Mir Tankov",
        "permalink": "mir-tankov",
        "drops": 1,
        "rewards": "5"
    },
    {
        "id": 104,
        "imagePath": "/games/united-1944.jpg",
        "name": "UNITED 1944",
        "permalink": "united-1944",
        "drops": 1,
        "rewards": "3"
    },
    {
        "id": 105,
        "imagePath": "/games/eco.jpg",
        "name": "Eco",
        "permalink": "eco",
        "drops": 3,
        "rewards": "12"
    },
    {
        "id": 106,
        "imagePath": "/games/mortal-online-2.jpg",
        "name": "Mortal Online 2",
        "permalink": "mortal-online-2",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 107,
        "imagePath": "/games/dungeon-defenders-ii.jpg",
        "name": "Dungeon Defenders II",
        "permalink": "dungeon-defenders-ii",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 108,
        "imagePath": "/games/skull-and-bones.jpg",
        "name": "Skull and Bones",
        "permalink": "skull-and-bones",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 109,
        "imagePath": "/games/escape-from-tarkov-arena.jpg",
        "name": "Escape from Tarkov: Arena",
        "permalink": "escape-from-tarkov-arena",
        "drops": 3,
        "rewards": "15"
    },
    {
        "id": 110,
        "imagePath": "/games/with-your-destiny.jpg",
        "name": "With Your Destiny",
        "permalink": "with-your-destiny",
        "drops": 3,
        "rewards": "4"
    },
    {
        "id": 111,
        "imagePath": "/games/ravendawn.jpg",
        "name": "Ravendawn",
        "permalink": "ravendawn",
        "drops": 3,
        "rewards": "13"
    },
    {
        "id": 112,
        "imagePath": "/games/west-hunt.jpg",
        "name": "West Hunt",
        "permalink": "west-hunt",
        "drops": 1,
        "rewards": "11"
    },
    {
        "id": 113,
        "imagePath": "/games/fishing-planet.jpg",
        "name": "Fishing Planet",
        "permalink": "fishing-planet",
        "drops": 1,
        "rewards": "4"
    },
    {
        "id": 114,
        "imagePath": "/games/palia.jpg",
        "name": "Palia",
        "permalink": "palia",
        "drops": 2,
        "rewards": "5"
    },
    {
        "id": 115,
        "imagePath": "/games/elite-dangerous.jpg",
        "name": "Elite: Dangerous",
        "permalink": "elite-dangerous",
        "drops": 4,
        "rewards": "9"
    },
    {
        "id": 116,
        "imagePath": "/games/house-flipper-2.jpg",
        "name": "House Flipper 2",
        "permalink": "house-flipper-2",
        "drops": 1,
        "rewards": "4"
    },
    {
        "id": 117,
        "imagePath": "/games/snowbreak-containment-zone.jpg",
        "name": "Snowbreak: Containment Zone",
        "permalink": "snowbreak-containment-zone",
        "drops": 2,
        "rewards": "8"
    },
    {
        "id": 83,
        "imagePath": "/games/kartrider-drift.jpg",
        "name": "KartRider: Drift",
        "permalink": "kartrider-drift",
        "drops": 2,
        "rewards": "6"
    },
    {
        "id": 118,
        "imagePath": "/games/warhammer-online-age-of-reckoning.jpg",
        "name": "Warhammer Online: Age of Reckoning",
        "permalink": "warhammer-online-age-of-reckoning",
        "drops": 1,
        "rewards": "4"
    },
    {
        "id": 119,
        "imagePath": "/games/marvel-snap.jpg",
        "name": "Marvel Snap",
        "permalink": "marvel-snap",
        "drops": 2,
        "rewards": "6"
    },
    {
        "id": 120,
        "imagePath": "/games/battle-teams-2.jpg",
        "name": "Battle Teams 2",
        "permalink": "battle-teams-2",
        "drops": 2,
        "rewards": "2"
    },
    {
        "id": 121,
        "imagePath": "/games/synced.jpg",
        "name": "SYNCED",
        "permalink": "synced",
        "drops": 1,
        "rewards": "9"
    },
    {
        "id": 122,
        "imagePath": "/games/the-finals.jpg",
        "name": "THE FINALS",
        "permalink": "the-finals",
        "drops": 2,
        "rewards": "6"
    },
    {
        "id": 123,
        "imagePath": "/games/dying-light-2-stay-human.jpg",
        "name": "Dying Light 2: Stay Human",
        "permalink": "dying-light-2-stay-human",
        "drops": 1,
        "rewards": "3"
    },
    {
        "id": 124,
        "imagePath": "/games/dont-starve-together.jpg",
        "name": "Don't Starve Together",
        "permalink": "dont-starve-together",
        "drops": 1,
        "rewards": "3"
    },
    {
        "id": 125,
        "imagePath": "/games/venatur.jpg",
        "name": "Venatur",
        "permalink": "venatur",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 126,
        "imagePath": "/games/torchlight-infinite.jpg",
        "name": "Torchlight: Infinite",
        "permalink": "torchlight-infinite",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 127,
        "imagePath": "/games/wwe-supercard.jpg",
        "name": "WWE SuperCard",
        "permalink": "wwe-supercard",
        "drops": 2,
        "rewards": "8"
    },
    {
        "id": 128,
        "imagePath": "/games/infestation-the-new-z.jpg",
        "name": "Infestation: The New Z",
        "permalink": "infestation-the-new-z",
        "drops": 3,
        "rewards": "4"
    },
    {
        "id": 129,
        "imagePath": "/games/trust-no-bunny.jpg",
        "name": "Trust No Bunny",
        "permalink": "trust-no-bunny",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 130,
        "imagePath": "/games/stalcraft.jpg",
        "name": "STALCRAFT",
        "permalink": "stalcraft",
        "drops": 7,
        "rewards": "40"
    },
    {
        "id": 131,
        "imagePath": "/games/freestyle-football-r.jpg",
        "name": "Freestyle Football R",
        "permalink": "freestyle-football-r",
        "drops": 2,
        "rewards": "5"
    },
    {
        "id": 132,
        "imagePath": "/games/clash-of-clans.jpg",
        "name": "Clash of Clans",
        "permalink": "clash-of-clans",
        "drops": 1,
        "rewards": "5"
    },
    {
        "id": 133,
        "imagePath": "/games/honkai-star-rail.jpg",
        "name": "Honkai: Star Rail",
        "permalink": "honkai-star-rail",
        "drops": 1,
        "rewards": "7"
    },
    {
        "id": 134,
        "imagePath": "/games/guardian-tales.jpg",
        "name": "Guardian Tales",
        "permalink": "guardian-tales",
        "drops": 1,
        "rewards": "5"
    },
    {
        "id": 135,
        "imagePath": "/games/rise-online.jpg",
        "name": "Rise Online",
        "permalink": "rise-online",
        "drops": 7,
        "rewards": "11"
    },
    {
        "id": 136,
        "imagePath": "/games/goddess-of-victory-nikke.jpg",
        "name": "GODDESS OF VICTORY: NIKKE",
        "permalink": "goddess-of-victory-nikke",
        "drops": 1,
        "rewards": "6"
    },
    {
        "id": 137,
        "imagePath": "/games/nw2online.jpg",
        "name": "NW2Online",
        "permalink": "nw2online",
        "drops": 1,
        "rewards": "1"
    },
    {
        "id": 90,
        "imagePath": "/games/stream-raiders.jpg",
        "name": "Stream Raiders",
        "permalink": "stream-raiders",
        "drops": 3,
        "rewards": "11"
    },
    {
        "id": 138,
        "imagePath": "/games/epic-seven.jpg",
        "name": "Epic Seven",
        "permalink": "epic-seven",
        "drops": 3,
        "rewards": "3"
    },
    {
        "id": 139,
        "imagePath": "/games/go-go-muffin.jpg",
        "name": "Go Go Muffin",
        "permalink": "go-go-muffin",
        "drops": 1,
        "rewards": "12"
    },
    {
        "id": 140,
        "imagePath": "/games/dead-by-daylight.jpg",
        "name": "Dead by Daylight",
        "permalink": "dead-by-daylight",
        "drops": 1,
        "rewards": "3"
    },
    {
        "id": 141,
        "imagePath": "/games/warhammer-40,000-warpforge.jpg",
        "name": "Warhammer 40,000: Warpforge",
        "permalink": "warhammer-40,000-warpforge",
        "drops": 1,
        "rewards": "6"
    },
    {
        "id": 142,
        "imagePath": "/games/suicide-squad-kill-the-justice-league.jpg",
        "name": "Suicide Squad: Kill the Justice League",
        "permalink": "suicide-squad-kill-the-justice-league",
        "drops": 1,
        "rewards": "3"
    },
    {
        "id": 143,
        "imagePath": "/games/halo-the-master-chief-collection.jpg",
        "name": "Halo: The Master Chief Collection",
        "permalink": "halo-the-master-chief-collection",
        "drops": 1,
        "rewards": "2"
    },
    {
        "id": 144,
        "imagePath": "/games/hellcard.jpg",
        "name": "Hellcard",
        "permalink": "hellcard",
        "drops": 1,
        "rewards": "12"
    },
    {
        "id": 145,
        "imagePath": "/games/one-punch-man-world.jpg",
        "name": "One Punch Man: World",
        "permalink": "one-punch-man-world",
        "drops": 1,
        "rewards": "7"
    }
])

const searchQuery = ref('')
const sortOption = ref('priority')
const sortDirection = ref('asc')

const toggleSortDirection = () => {
  sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc'
}

const filteredGames = computed(() => {
  if (!searchQuery.value) return games.value
  const query = searchQuery.value.toLowerCase()
  return games.value.filter(game => 
    game.name.toLowerCase().includes(query)
  )
})

const sortedAndFilteredGames = computed(() => {
  const filtered = filteredGames.value
  
  return [...filtered].sort((a, b) => {
    let comparison = 0
    
    switch (sortOption.value) {
      case 'priority':
        comparison = (b.priority ? 1 : 0) - (a.priority ? 1 : 0)
        break
      case 'name':
        comparison = a.name.localeCompare(b.name)
        break
      case 'drops':
        comparison = b.total_drops - a.total_drops
        break
      case 'rewards':
        comparison = parseInt(b.total_rewards) - parseInt(a.total_rewards)
        break
      case 'newest':
        comparison = new Date(b.created_at) - new Date(a.created_at)
        break
    }
    
    return sortDirection.value === 'asc' ? comparison : -comparison
  })
})

const getImageUrl = (filename) => {
  // return `/games/${filename}`
  return `${filename}`
}

const handleGameClick = (game) => {
  console.log('Game clicked:', game.permalink)
  // router.push(`/drops/games/${game.permalink}`)
}
</script>

<style scoped>
.drops-home {
  padding: 20px;
}

.control-panel {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  align-items: center;
  flex-wrap: wrap;
}

.search-bar {
  flex: 1;
  min-width: 300px;
}

.search-input {
  width: 100%;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid #3d3654;
  background-color: #2d2640;
  color: white;
  font-size: 14px;
  outline: none;
}

.search-input::placeholder {
  color: #a8a4b4;
}

.search-input:focus {
  border-color: #7c3aed;
}

.sort-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.sort-select {
  padding: 10px 16px;
  border-radius: 6px;
  border: 1px solid #3d3654;
  background-color: #2d2640;
  color: white;
  font-size: 14px;
  outline: none;
  cursor: pointer;
}

.sort-direction-btn {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #3d3654;
  background-color: #2d2640;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sort-direction-btn .arrow-icon {
  transition: transform 0.2s ease;
}

.sort-direction-btn.desc .arrow-icon {
  transform: rotate(180deg);
}

.info-banner {
  background-color: rgba(61, 54, 84, 0.5);
  padding: 12px 20px;
  border-radius: 6px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #a8a4b4;
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.game-card {
  background-color: #211d2d;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;
}

.game-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.game-card.priority {
  border: 2px solid #7c3aed;
}

.priority-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: #7c3aed;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.game-image {
  width: 100%;
  height: 160px;
  overflow: hidden;
  background-color: #1a1625;
  position: relative;
}

.game-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.game-card:hover .game-image img {
  transform: scale(1.05);
}

.game-info {
  padding: 16px;
}

.game-title {
  color: white;
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.game-stats {
  display: flex;
  gap: 16px;
  font-size: 14px;
}

.drops {
  color: #7c3aed;
}

.rewards {
  color: #f59e0b;
}

@media (max-width: 1200px) {
  .games-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

@media (max-width: 768px) {
  .control-panel {
    flex-direction: column;
  }
  
  .search-bar {
    width: 100%;
  }
  
  .sort-controls {
    width: 100%;
  }
  
  .sort-select {
    flex: 1;
  }
}

</style>